import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '~/shadcn/ui/dialog'
import type { IAgreementPreview } from '~/@api/generated-api-types-user/Api'
import { Text } from '~/@mid_ui/typography/Text'
import { AgreementPreview } from '~/@mid_ui/agreement-preview/AgreementPreview'

type Props = {
  agreement?: IAgreementPreview
  error?: string | null
}

function MainAgreementPreview({ agreement, error }: Props) {
  return (
    <div className="flex flex-col overflow-auto md:px-15 md:pt-12 md:pb-13">
      {agreement != null && (
        <DialogHeader className="gap-0">
          <DialogDescription title={agreement.sk.title} />
          <DialogTitle title={agreement.sk.title}>
            {agreement.sk.title}
          </DialogTitle>
        </DialogHeader>
      )}
      {agreement == null && (
        <>
          <Text>Dohoda nebola nájdená</Text>
        </>
      )}

      {agreement != null && (
        <>
          {error && <Text>{error}</Text>}

          <div className="flex flex-col">
            <div>
              <AgreementPreview
                agreementSk={agreement.sk}
                agreementLang={agreement.lang}
              />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export { MainAgreementPreview }
